import * as React from 'react';
import { useTranslate, useGetList } from 'react-admin';
import CardWithIcon from './CardWithIcon';

import StorefrontIcon from '@mui/icons-material/Storefront';

const TotalStores = () => {
    const translate = useTranslate();

    const { total } = useGetList('producers/stores');
    return (
        <CardWithIcon
            to="/producers/stores"
            icon={StorefrontIcon}
            title="Établissements"
            subtitle={total}
        />
    );
};

export default TotalStores;